export default {
  primary: {
    backgroundColor: 'blue.0',
    color: 'white.0',
    '*': {
      fill: 'white.0'
    }
  },
  success: {
    backgroundColor: 'green.0',
    color: 'white.0',
    '*': {
      fill: 'white.0'
    }
  },
  danger: {
    backgroundColor: 'red.0',
    color: 'white.0',
    '*': {
      fill: 'white.0'
    }
  },
  warning: {
    backgroundColor: 'yellow.0',
    color: 'dark.0',
    '*': {
      fill: 'dark.0'
    }
  }
}
